import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch from '@mui/material/Switch';
import type { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import { forwardRef, type Ref } from 'react';

export type SwitchProps = Pick<MuiSwitchProps, 'checked' | 'defaultChecked' | 'disabled' | 'onChange' | 'onClick'> & {
  /** When set, the switch is wrapped in `FormControlLabel`; label styles come from the switch theme. */
  label?: string;
  name?: string;
  inputRef?: Ref<HTMLInputElement>;
  /** For switches without a visible label (e.g. icon-only toolbars). */
  'aria-label'?: string;
};

/** Design-system Switch — always `medium` size and `secondary` track when checked. */
export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(function Switch(
  { label, checked, defaultChecked, disabled, name, onChange, onClick, inputRef, 'aria-label': ariaLabel },
  ref
) {
  const control = (
    <MuiSwitch
      ref={ref}
      className="SmSwitch-root"
      size="medium"
      color="secondary"
      dir="rtl"
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      name={name}
      onChange={onChange}
      onClick={onClick}
      inputRef={inputRef}
      inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
    />
  );

  if (label != null && label !== '') {
    return <FormControlLabel className="SmSwitch-formLabel" disabled={disabled} control={control} label={label} />;
  }

  return control;
});
